// extracted by mini-css-extract-plugin
export default {"root":"account-button_root__qliMO","button":"account-button_button__R8v+r"};